
import { defineComponent } from 'vue';
import BgImage from '@/views/public/landingpage/components/freelancer/BgImage.vue';
import useFreelancerLandingPage from '@/views/public/landingpage/components/freelancer/useFreelancerLandingPage';

export default defineComponent({
  name: 'FreelancerLogo',
  components: { BgImage },
  setup() {
    const { tl } = useFreelancerLandingPage();
    return {
      tl
    };
  }
});
